const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/public/cartographies/$id.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/public/cartographies/$id.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { LoadingSpinner } from '~/components/LoadingSpinner';
import { publicCartographyQueryOptions } from '~/queries/cartography';
export const Route = createFileRoute('/public/cartographies/$id')({
  loader: ({
    context,
    params
  }) => context.queryClient.ensureQueryData(publicCartographyQueryOptions(params.id)),
  pendingComponent: PublicCartographyPending,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
function PublicCartographyPending() {
  return <div className="flex items-center justify-center h-full">
			<LoadingSpinner size="small" />
		</div>;
}